/* AMC Bright 2026 extras (sitewide, deferred). Loaded from snippets/amc-page-transition.liquid.
   1. Header search: live results as the customer types (products, suggestions, collections),
      popular searches before typing, full keyboard support. Uses Shopify's predictive search endpoint. */
(() => {
  if (window.__amcBrightExtras) return;
  window.__amcBrightExtras = true;

  const POPULAR = ['Mortuary cooler', 'Walk-in cooler', 'Mortuary cot', 'Embalming table', 'Body lift', 'Cadaver rack'];
  const esc = (value) => String(value == null ? '' : value).replace(/[&<>"']/g, (c) => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]));
  const money = (value) => {
    const number = Number(value);
    if (!isFinite(number)) return '';
    return new Intl.NumberFormat('en-US', { style: 'currency', currency: (window.Shopify && Shopify.currency && Shopify.currency.active) || 'USD' }).format(number);
  };
  const sized = (url, width) => (url ? url + (url.indexOf('?') > -1 ? '&' : '?') + 'width=' + width : '');
  const ICON = '<svg viewBox="0 0 24 24" aria-hidden="true" focusable="false"><circle cx="11" cy="11" r="6.5"/><path d="m16 16 4.5 4.5"/></svg>';

  const css = `
.amc-hdr__searchrow{position:relative}
.amc-hdr__search input[type=search]{text-overflow:ellipsis}
.amc-hdr__search input[type=search]::placeholder{text-overflow:ellipsis;overflow:hidden;white-space:nowrap}
.amc-sx{position:absolute;z-index:60;left:0;right:0;top:100%;display:none;box-sizing:border-box;padding:0 12px 12px;pointer-events:none}
.amc-sx.is-open{display:block}
.amc-sx__panel{box-sizing:border-box;width:min(760px,100%);max-height:min(72vh,640px);margin:0 auto;padding:8px;overflow:auto;overscroll-behavior:contain;border-radius:0 0 22px 22px;background:#fff;box-shadow:0 28px 48px -18px rgba(6,26,53,.42),0 0 0 1px rgba(6,26,53,.06);color:#061A35;font-family:inherit;pointer-events:auto;-webkit-overflow-scrolling:touch}
.amc-sx__veil{position:fixed;z-index:-1;inset:0;background:rgba(6,26,53,.38);pointer-events:auto}
.amc-sx__head{margin:0;padding:12px 12px 6px;color:#5E7080;font-size:11px;font-weight:800;letter-spacing:.12em;line-height:1.2;text-transform:uppercase}
.amc-sx__chips{display:flex;flex-wrap:wrap;gap:8px;margin:0;padding:4px 12px 10px;list-style:none}
.amc-sx__chips a{display:inline-flex;align-items:center;gap:7px;min-height:40px;padding:0 15px;border-radius:999px;background:#F5F5F7;color:#061A35;font-size:14px;font-weight:700;line-height:1;text-decoration:none}
.amc-sx__chips svg,.amc-sx__q svg{flex:0 0 16px;width:16px;height:16px;fill:none;stroke:#5E7080;stroke-width:2;stroke-linecap:round}
.amc-sx__list{margin:0;padding:0;list-style:none}
.amc-sx__q{display:flex;align-items:center;gap:12px;min-height:44px;padding:0 12px;border-radius:12px;color:#061A35;font-size:15px;font-weight:500;line-height:1.25;text-decoration:none}
.amc-sx__q mark{background:none;color:inherit;font-weight:800}
.amc-sx__p{display:grid;grid-template-columns:56px minmax(0,1fr) auto;align-items:center;gap:12px;min-height:68px;padding:6px 12px 6px 6px;border-radius:14px;color:#061A35;text-decoration:none}
.amc-sx__thumb{display:block;width:56px;height:56px;border-radius:12px;background:#F5F5F7;overflow:hidden}
.amc-sx__thumb img{display:block;width:100%;height:100%;object-fit:contain;mix-blend-mode:multiply}
.amc-sx__name{display:-webkit-box;overflow:hidden;font-size:14px;font-weight:700;letter-spacing:-.005em;line-height:1.25;-webkit-box-orient:vertical;-webkit-line-clamp:2}
.amc-sx__type{display:block;margin-top:3px;overflow:hidden;color:#5E7080;font-size:11px;font-weight:600;line-height:1.2;text-overflow:ellipsis;white-space:nowrap}
.amc-sx__price{display:flex;flex-direction:column;align-items:flex-end;gap:2px;color:#D71920;font-size:14px;font-weight:800;line-height:1.1;white-space:nowrap}
.amc-sx__price s{color:#5E7080;font-size:11px;font-weight:600}
.amc-sx__price small{color:#5E7080;font-size:10px;font-weight:700;letter-spacing:.06em;text-transform:uppercase}
.amc-sx a:hover,.amc-sx a.is-active{background:#F5F5F7}
.amc-sx__chips a:hover,.amc-sx__chips a.is-active{background:#E6E8EC}
.amc-sx a:focus-visible{outline:2px solid #1A5CFF;outline-offset:-2px}
.amc-sx__all{display:flex;align-items:center;justify-content:center;gap:10px;min-height:50px;margin:8px 4px 4px;padding:0 18px;border-radius:999px;background:#D71920;color:#fff;font-size:15px;font-weight:800;line-height:1;text-decoration:none}
.amc-sx a.amc-sx__all:hover,.amc-sx a.amc-sx__all.is-active{background:#061A35}
.amc-sx__empty{margin:0;padding:14px 12px 6px;font-size:15px;font-weight:600;line-height:1.4}
.amc-sx__skel{display:grid;grid-template-columns:56px 1fr;align-items:center;gap:12px;padding:6px 12px 6px 6px}
.amc-sx__skel i{display:block;height:56px;border-radius:12px;background:linear-gradient(90deg,#F0F1F4 25%,#F8F9FA 45%,#F0F1F4 65%) 0 0/300% 100%;animation:amcSxShimmer 1.1s linear infinite}
.amc-sx__skel i+i{height:14px;width:70%;border-radius:7px}
@keyframes amcSxShimmer{to{background-position:-150% 0}}
@media(max-width:749px){
.amc-sx{padding:0}
.amc-sx__panel{width:100%;max-height:calc(100dvh - var(--amc-sx-top,130px));border-radius:0 0 20px 20px;padding:6px 6px 14px}
.amc-sx__q{min-height:48px;font-size:16px}
}
@media(prefers-reduced-motion:reduce){.amc-sx__skel i{animation:none}}
`;

  const init = () => {
    const form = document.querySelector('.amc-hdr__search');
    const input = form && form.querySelector('input[name="q"]');
    if (!form || !input || form.dataset.amcSx) return;
    form.dataset.amcSx = 'true';
    const row = form.closest('.amc-hdr__searchrow') || form.parentElement;

    const style = document.createElement('style');
    style.id = 'amc-search-style';
    style.textContent = css;
    document.head.append(style);

    const longHint = input.getAttribute('placeholder') || 'Search';
    const narrow = matchMedia('(max-width: 749px)');
    const setHint = () => { input.setAttribute('placeholder', narrow.matches ? 'Search equipment and supplies' : longHint); };
    setHint();
    narrow.addEventListener('change', setHint);

    const box = document.createElement('div');
    box.className = 'amc-sx';
    box.innerHTML = '<div class="amc-sx__veil" data-sx-close></div><div class="amc-sx__panel" id="amc-sx-panel" role="listbox" aria-label="Search suggestions"></div>';
    row.append(box);
    const panel = box.querySelector('.amc-sx__panel');
    input.setAttribute('role', 'combobox');
    input.setAttribute('aria-autocomplete', 'list');
    input.setAttribute('aria-controls', 'amc-sx-panel');
    input.setAttribute('aria-expanded', 'false');
    input.setAttribute('enterkeyhint', 'search');

    const cache = new Map();
    let controller = null;
    let timer = 0;
    let active = -1;
    let lastQuery = null;

    const items = () => [...panel.querySelectorAll('a[data-sx-item]')];
    const setActive = (index) => {
      const list = items();
      active = list.length ? (index + list.length) % list.length : -1;
      list.forEach((item, i) => {
        item.classList.toggle('is-active', i === active);
        item.setAttribute('aria-selected', String(i === active));
      });
      if (active > -1) {
        list[active].scrollIntoView({ block: 'nearest' });
        input.setAttribute('aria-activedescendant', list[active].id);
      } else {
        input.removeAttribute('aria-activedescendant');
      }
    };
    const open = () => {
      if (box.classList.contains('is-open')) return;
      box.style.setProperty('--amc-sx-top', Math.round(row.getBoundingClientRect().bottom) + 'px');
      box.classList.add('is-open');
      input.setAttribute('aria-expanded', 'true');
    };
    const close = () => {
      box.classList.remove('is-open');
      input.setAttribute('aria-expanded', 'false');
      active = -1;
    };
    const paint = (html) => {
      panel.innerHTML = html;
      items().forEach((item, i) => { item.id = 'amc-sx-item-' + i; item.setAttribute('role', 'option'); });
      active = -1;
      input.removeAttribute('aria-activedescendant');
    };
    const searchUrl = (query) => '/search?q=' + encodeURIComponent(query) + '&type=product';
    const chips = (title) => '<p class="amc-sx__head">' + title + '</p><ul class="amc-sx__chips" role="presentation">' + POPULAR.map((term) => '<li role="presentation"><a data-sx-item href="' + searchUrl(term) + '">' + ICON + esc(term) + '</a></li>').join('') + '</ul>';
    const skeleton = () => '<p class="amc-sx__head">Searching</p>' + '<div class="amc-sx__skel"><i></i><i></i></div>'.repeat(4);

    const render = (query, data) => {
      const results = (data && data.resources && data.resources.results) || {};
      const queries = (results.queries || []).slice(0, 4);
      const products = (results.products || []).slice(0, 6);
      const collections = (results.collections || []).slice(0, 4);
      let html = '';
      if (queries.length) {
        html += '<p class="amc-sx__head">Suggestions</p><ul class="amc-sx__list" role="presentation">' + queries.map((entry) => {
          const label = entry.styled_text ? String(entry.styled_text).replace(/<(?!\/?(mark|span)\b)[^>]*>/gi, '').replace(/<span[^>]*>/gi, '<mark>').replace(/<\/span>/gi, '</mark>') : esc(entry.text);
          return '<li role="presentation"><a class="amc-sx__q" data-sx-item href="' + esc(entry.url || searchUrl(entry.text)) + '">' + ICON + '<span>' + label + '</span></a></li>';
        }).join('') + '</ul>';
      }
      if (products.length) {
        html += '<p class="amc-sx__head">Products</p><ul class="amc-sx__list" role="presentation">' + products.map((product) => {
          const image = (product.featured_image && product.featured_image.url) || product.image || '';
          const min = Number(product.price_min || product.price);
          const max = Number(product.price_max || product.price);
          const compare = Number(product.compare_at_price_min || product.compare_at_price_max || 0);
          const title = String(product.title || '').split(' | ')[0];
          return '<li role="presentation"><a class="amc-sx__p" data-sx-item href="' + esc(product.url) + '">' +
            '<span class="amc-sx__thumb">' + (image ? '<img src="' + esc(sized(image, 160)) + '" alt="" width="56" height="56" loading="lazy" decoding="async">' : '') + '</span>' +
            '<span><span class="amc-sx__name">' + esc(title) + '</span>' + (product.type ? '<span class="amc-sx__type">' + esc(product.type) + '</span>' : '') + '</span>' +
            '<span class="amc-sx__price">' + (max > min ? '<small>From</small>' : '') + (compare > min ? '<s>' + money(compare) + '</s>' : '') + money(min) + '</span>' +
            '</a></li>';
        }).join('') + '</ul>';
      }
      if (collections.length) {
        html += '<p class="amc-sx__head">Collections</p><ul class="amc-sx__chips" role="presentation">' + collections.map((collection) => '<li role="presentation"><a data-sx-item href="' + esc(collection.url) + '">' + esc(collection.title) + '</a></li>').join('') + '</ul>';
      }
      if (!html) {
        html = '<p class="amc-sx__empty">No matches for &ldquo;' + esc(query) + '&rdquo; yet. Try a model number or one of these.</p>' + chips('Popular searches');
      } else {
        html += '<a class="amc-sx__all" data-sx-item href="' + searchUrl(query) + '">See all results for &ldquo;' + esc(query) + '&rdquo; <span aria-hidden="true">&rarr;</span></a>';
      }
      paint(html);
    };

    const run = async (query) => {
      if (cache.has(query)) { render(query, cache.get(query)); return; }
      if (controller) controller.abort();
      controller = new AbortController();
      if (!panel.querySelector('[data-sx-item]') || lastQuery === '') paint(skeleton());
      try {
        const root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
        const response = await fetch(root + 'search/suggest.json?q=' + encodeURIComponent(query) + '&resources[type]=product,collection,query&resources[limit]=6&resources[limit_scope]=each&resources[options][unavailable_products]=last', { signal: controller.signal, headers: { Accept: 'application/json' } });
        if (!response.ok) throw new Error(String(response.status));
        const data = await response.json();
        cache.set(query, data);
        if (input.value.trim() === query) render(query, data);
      } catch (error) {
        if (error && error.name === 'AbortError') return;
        paint('<a class="amc-sx__all" data-sx-item href="' + searchUrl(query) + '">Search for &ldquo;' + esc(query) + '&rdquo; <span aria-hidden="true">&rarr;</span></a>');
      }
    };

    const update = () => {
      const query = input.value.trim();
      open();
      if (query === lastQuery) return;
      clearTimeout(timer);
      if (query.length < 2) {
        if (controller) controller.abort();
        paint(chips('Popular searches'));
        lastQuery = query === '' ? '' : null;
        return;
      }
      timer = setTimeout(() => { run(query); lastQuery = query; }, 130);
    };

    input.addEventListener('input', update);
    input.addEventListener('focus', update);
    input.addEventListener('keydown', (event) => {
      if (event.key === 'ArrowDown') { event.preventDefault(); open(); setActive(active + 1); }
      else if (event.key === 'ArrowUp') { event.preventDefault(); setActive(active - 1); }
      else if (event.key === 'Escape') { if (box.classList.contains('is-open')) { event.preventDefault(); close(); } }
      else if (event.key === 'Enter' && active > -1) { const target = items()[active]; if (target) { event.preventDefault(); target.click(); } }
    });
    box.addEventListener('click', (event) => { if (event.target.closest('[data-sx-close]')) close(); });
    document.addEventListener('pointerdown', (event) => { if (!row.contains(event.target)) close(); });
    document.addEventListener('focusin', (event) => { if (!row.contains(event.target)) close(); });
    new MutationObserver(() => { if (row.hidden) close(); else if (document.activeElement === input) update(); }).observe(row, { attributes: true, attributeFilter: ['hidden'] });
    if (document.activeElement === input) update();
  };

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init, { once: true });
  else init();
  document.addEventListener('shopify:section:load', () => setTimeout(init, 0));
})();
